import { ETagType, renderStringToReact } from '@web_opxp/features';
import { CheckIcon } from '@web_opxp/icons';
import * as React from 'react';

export interface IBenefitItemProps {
  href?: string;
  html: string;
}

const BenefitItem: React.FC<IBenefitItemProps> = ({ href, html }) => {
  const itemContent = (
    <>
      <CheckIcon /> {renderStringToReact(html, ETagType.span)}
    </>
  );
  const linkWrapper = href ? <a href={href}>{itemContent}</a> : itemContent;
  return (
    <div className="col-4 col-m-4">
      <p>{linkWrapper}</p>
    </div>
  );
};

export default BenefitItem;
